import phone from "assets/images/user-phone.svg";
import mail from "assets/images/user-mail.svg";
import Location from "assets/images/location.svg";
import clock from "assets/images/clock.svg";
import lang from "assets/images/user-lang.svg";
import orderIcon from "assets/images/order-white-icon.svg";
import sessionDarkIcon from "assets/images/session-dark-icon.svg";
import orderDarkIcon from "assets/images/order-dark-icon.svg";
import sessionIcon from "assets/images/session-white-icon.svg";
import dietary from "assets/images/dietary-white-icon.svg";
import {
  Container,
  CardContainer,
  TabeContainer,
  TabeCart,
  StatusTabeContainer,
} from "./styled";
import { dispatch } from "store";
import {
  setUserActiveButton,
  setUserStatusActiveButton,
} from "store/user-slice";
import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import placeHolderImage from "assets/images/place-img.png";
import Pagination from "components/particles/pagination/pagination";
import Button from "components/particles/primary-button";
import NoDataFound from "components/particles/no-data-found";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import { useLocation, useNavigate } from "react-router-dom";
import view from "assets/images/view-icon.svg";
import DietaryChoisePopup from "components/popus/dietary-choise";
import StatusTabe from "components/particles/status-tabe";
import { Status } from "containers/home-chefs/view/styled";
import { useForm } from "react-hook-form";
import {
  UsersViewOrdersSearchDTO,
  UsersViewSessionSearchDTO,
} from "utils/helpers/models/users.dto";
import useUserDetails from "./useHook";

export default function View() {
  const [data, setData] = useState<any>([]);
  const [ordersPaginationState, setOrdersPaginationState] = useState<any>();
  const [sessionsPaginationState, setSessionsPaginationState] = useState<any>();
  const [orderData, setOrderData] = useState<any>([]);
  const [sessionData, setSessionData] = useState<any>([]);
  const [modalData, setModalData] = useState<any>(null);
  const [filterValues, setFilterValues] = useState<
    Partial<UsersViewOrdersSearchDTO | UsersViewSessionSearchDTO>
  >({});

  console.log(modalData, "modalData");


  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;

  const { getUserViewById, getOrderByUserById, getSessionByUserById } =
    useUserDetails();

  const { userActiveButton, userStatusActiveButton, isLoading } = useSelector(
    (reduxState: any) => reduxState.user
  );

  const [modalIsOpen, setIsOpen] = useState(false);

  const {
    register,
    handleSubmit,
    reset: formReset,
  } = useForm<UsersViewOrdersSearchDTO | UsersViewSessionSearchDTO>();

  useEffect(() => {
    if (state?.id) {
      getUserViewById(state.id, setData);
    }
  }, [state?.id]);

  useEffect(() => {
    if (state?.id) {
      const { status, orderId, createdAt, retailerName } = state;
      const statusFilter = status === "All" ? "" : status;

      getOrderByUserById(
        state.id,
        statusFilter,
        orderId,
        createdAt,
        retailerName,
        setOrderData,
        setOrdersPaginationState
      );
    }
  }, [state?.id]);

  useEffect(() => {
    if (state?.id) {
      const { status, sessionId, dishName, createdOn, homeCookName } = state;
      const statusFilter = status === "All" ? "" : status;

      getSessionByUserById(
        state.id,
        statusFilter,
        setSessionData,
        sessionId,
        dishName,
        createdOn,
        homeCookName,
        setSessionsPaginationState
      );
    }
  }, [state?.id]);

  function onStatusChange(
    type: "Session" | "Order",
    userId: string,
    status: string
  ) {
    const actualStatus = status === "All" ? "" : status;

    if (type === "Session") {
      getSessionByUserById(
        userId,
        actualStatus,
        setSessionData,
        "",
        "",
        "",
        "",
        setSessionsPaginationState
      );
    } else if (type === "Order") {
      getOrderByUserById(
        userId,
        actualStatus,
        "",
        "",
        "",
        setOrderData,
        setOrdersPaginationState
      );
    }
  }

  // const search = (
  //   formData: UsersViewOrdersSearchDTO | UsersViewSessionSearchDTO
  // ) => {
  //   const statusFilter =
  //     userStatusActiveButton === "All" ? "" : userStatusActiveButton;

  //   if (userActiveButton === "Session Details") {
  //     getSessionByUserById(
  //       state.id,
  //       statusFilter,
  //       setSessionData,
  //       "id" in formData ? formData.id : undefined,
  //       "name" in formData ? formData.name : undefined,
  //       "date" in formData ? formData.date : undefined,
  //       "cook" in formData ? formData.cook : undefined,
  //       setSessionsPaginationState
  //     );
  //   } else if (userActiveButton === "Order Details") {
  //     getOrderByUserById(
  //       state.id,
  //       statusFilter,
  //       "id" in formData ? formData.id : undefined,
  //       "date" in formData ? formData.date : undefined,
  //       "retailer" in formData ? formData.retailer : undefined,
  //       setOrderData,
  //       setOrdersPaginationState
  //     );
  //   }
  // };
  const search = (
    formData: UsersViewOrdersSearchDTO | UsersViewSessionSearchDTO
  ) => {
    const statusFilter =
      userStatusActiveButton === "All" ? "" : userStatusActiveButton;

    // ✅ Save filter values for later (pagination)
    setFilterValues(formData);

    if (userActiveButton === "Session Details") {
      getSessionByUserById(
        state.id,
        statusFilter,
        setSessionData,
        "id" in formData ? formData.id : undefined,
        "name" in formData ? formData.name : undefined,
        "date" in formData ? formData.date : undefined,
        "cook" in formData ? formData.cook : undefined,
        setSessionsPaginationState
      );
    } else if (userActiveButton === "Order Details") {
      getOrderByUserById(
        state.id,
        statusFilter,
        "id" in formData ? formData.id : undefined,
        "date" in formData ? formData.date : undefined,
        "retailer" in formData ? formData.retailer : undefined,
        setOrderData,
        setOrdersPaginationState
      );
    }
  };

  // function handleResetFilters() {
  //   formReset({
  //     name: "",
  //     date: "",
  //     cook: "",
  //     retailer: "",
  //     status: "",
  //     id: "",
  //   });

  //   if (userActiveButton === "Session Details") {
  //     getSessionByUserById(
  //       state.id,
  //       "",
  //       setSessionData,
  //       "",
  //       "",
  //       "",
  //       "",
  //       setSessionsPaginationState
  //     );
  //   } else if (userActiveButton === "Order Details") {
  //     getOrderByUserById(
  //       state.id,
  //       "",
  //       "",
  //       "",
  //       "",
  //       setOrderData,
  //       setOrdersPaginationState
  //     );
  //   }
  // }

  // function fetchNextRecords(offset: number) {
  //   const actualStatus =
  //     userStatusActiveButton === "All" ? "" : userStatusActiveButton;

  //   const limit = 10;

  //   if (userActiveButton === "Session Details") {
  //     getSessionByUserById(
  //       state.id,
  //       actualStatus,
  //       setSessionData,
  //       "",
  //       "",
  //       "",
  //       "",
  //       setSessionsPaginationState,
  //       limit,
  //       offset
  //     );
  //   } else if (userActiveButton === "Order Details") {
  //     getOrderByUserById(
  //       state.id,
  //       actualStatus,
  //       "",
  //       "",
  //       "",
  //       setOrderData,
  //       setOrdersPaginationState,
  //       limit,
  //       offset
  //     );
  //   }

  //   setTimeout(() => {
  //     const toTopElement = document.getElementById("toTop");
  //     if (toTopElement) {
  //       toTopElement.scrollIntoView({ behavior: "smooth", block: "start" });
  //     } else {
  //       window.scrollTo({ top: 0, behavior: "smooth" });
  //     }
  //   }, 100);
  // }
  function handleResetFilters() {
  formReset({
    name: "",
    date: "",
    cook: "",
    retailer: "",
    status: "",
    id: "",
  });

  // Clear saved filters
  setFilterValues({});

  const statusFilter =
    userStatusActiveButton === "All" ? "" : userStatusActiveButton;

  if (userActiveButton === "Session Details") {
    getSessionByUserById(
      state.id,
      statusFilter, // ✅ Use current tab's status
      setSessionData,
      "",
      "",
      "",
      "",
      setSessionsPaginationState
    );
  } else if (userActiveButton === "Order Details") {
    getOrderByUserById(
      state.id,
      statusFilter, // ✅ Use current tab's status
      "",
      "",
      "",
      setOrderData,
      setOrdersPaginationState
    );
  }
}

  function fetchNextRecords(offset?: number) {
    const actualStatus =
      userStatusActiveButton === "All" ? "" : userStatusActiveButton;

    const limit = 10;

    if (userActiveButton === "Session Details") {
      getSessionByUserById(
        state.id,
        actualStatus,
        setSessionData,
        "id" in filterValues ? filterValues.id : undefined,
        "name" in filterValues ? filterValues.name : undefined,
        "date" in filterValues ? filterValues.date : undefined,
        "cook" in filterValues ? filterValues.cook : undefined,
        setSessionsPaginationState,
        limit,
        offset
      );
    } else if (userActiveButton === "Order Details") {
      getOrderByUserById(
        state.id,
        actualStatus,
        "id" in filterValues ? filterValues.id : undefined,
        "date" in filterValues ? filterValues.date : undefined,
        "retailer" in filterValues ? filterValues.retailer : undefined,
        setOrderData,
        setOrdersPaginationState,
        limit,
        offset
      );
    }

    // setTimeout(() => {
    //   const toTopElement = document.getElementById("toTop");
    //   if (toTopElement) {
    //     toTopElement.scrollIntoView({ behavior: "smooth", block: "start" });
    //   } else {
    //     window.scrollTo({ top: 0, behavior: "smooth" });
    //   }
    // }, 100);
  }


  function dietaryModalOpen(dietaryData: any) {
    console.log(dietaryData);
    
    setModalData(dietaryData);
    setIsOpen(true);
  }

  const handleDishViewPage = (userId: string, dishId: number ,sessionId: string) => {
    navigate(siteRoutes.usersViewDetail, { state: { dishId, userId,sessionId } });
  };

  const handleOrderViewPage = (userId: string, orderId: number) => {
    navigate(siteRoutes.usersViewPrint, { state: { orderId, userId } });
  };

  useEffect(() => {
    dispatch(setUserActiveButton("Order Details"));
    dispatch(setUserStatusActiveButton("All"));
  }, []);

  useEffect(() => {
    formReset({
      id: "",
      date: "",
      name: "",
      cook: "",
      retailer: "",
      status: "",
    });
    setFilterValues({});
    // setSessionData([]);
    // setOrderData([]);
    fetchNextRecords()
  }, [userActiveButton]);
const pref = data?.[0]?.dietaryPreferences; 
console.log(pref);
  


  return (
    <Container id="toTop">
      <div className="title">
        <h1>User Profile</h1>
            <div onClick={() => dietaryModalOpen(pref)}>
              <button className="button">
                <div className="dietary-icon">
                  <img src={dietary} alt="" />
                </div>
                <h3>Dietary Preference</h3>
              </button>
            </div>
      </div>

      {data?.length > 0 ? (
        data.map((item: any, index: number) => (
          <CardContainer key={index}>
            <div className="profile-header">
            <div>
              <img src={item?.image || placeHolderImage} alt="img" className="profile-img" />
            </div>
            <div className="profile">
              <h1>{item?.name}</h1>
              <p>{item?.bio}</p>
            </div>
            </div>
            <div className="user-info">
              <div className="info-row">
                <img src={mail} alt="mail" />
                <p>{item?.email}</p>
              </div>
              <div className="info-row">
                <img src={phone} alt="phone" />
                <p>({item?.countryCode})-{item?.mobileNumber}</p>
              </div>
              <div className="info-row">
                <img src={clock} alt="dob" />
                <p>{item?.dob ? item.dob.split("T")[0] : "N/A"}</p>
              </div>
              <div className="info-row">
                <img src={lang} alt="language" />
                <p>
                  {item?.language?.length ? item.language.join(", ") : "N/A"}
                </p>
              </div>
              <div className="info-row">
                <img src={Location} alt="location" />
                <p>{item?.address}</p>
              </div>
            </div>
          </CardContainer>
        ))
      ) : (
        <p>Loading user data...</p>
      )}

      <TabeContainer>
        <TabeCart
          active={userActiveButton === "Order Details"}
          onClick={() => {
            dispatch(setUserActiveButton("Order Details"));
          }}
        >
          <div className="categories-tab-img">
            <img
              src={
                userActiveButton === "Order Details" ? orderIcon : orderDarkIcon
              }
              alt="img"
            />
          </div>
          <h1>Order Details</h1>
        </TabeCart>
        <TabeCart
          active={userActiveButton === "Session Details"}
          onClick={() => {
            dispatch(setUserActiveButton("Session Details"));
          }}
        >
          <div className="categories-tab-img">
            <img
              src={
                userActiveButton === "Session Details"
                  ? sessionIcon
                  : sessionDarkIcon
              }
              alt="img"
            />
          </div>
          <h1>Session Details</h1>
        </TabeCart>
      </TabeContainer>

      <StatusTabeContainer>
        {userActiveButton === "Session Details" ? (
          <>
            <StatusTabe
              active={userStatusActiveButton === "All"}
              onclick={() => {
                onStatusChange("Session", state.id, "All");
                dispatch(setUserStatusActiveButton("All"));
              }}
              title="All"
            />
            <StatusTabe
              active={userStatusActiveButton === "incoming"}
              onclick={() => {
                onStatusChange("Session", state.id, "incoming");
                dispatch(setUserStatusActiveButton("incoming"));
              }}
              title="Incoming"
            />
            <StatusTabe
              active={userStatusActiveButton === "readyToPay"}
              onclick={() => {
                onStatusChange("Session", state.id, "readyToPay");
                dispatch(setUserStatusActiveButton("readyToPay"));
              }}
              title="Pending Payment"
            />
            <StatusTabe
              active={userStatusActiveButton === "paid"}
              onclick={() => {
                onStatusChange("Session", state.id, "paid");
                dispatch(setUserStatusActiveButton("paid"));
              }}
              title="Paid"
            />
            <StatusTabe
              active={userStatusActiveButton === "active"}
              onclick={() => {
                onStatusChange("Session", state.id, "active");
                dispatch(setUserStatusActiveButton("active"));
              }}
              title="Active"
            />
            {/* <StatusTabe
                active={userStatusActiveButton === "pending"}
                onclick={() => {
                  onStatusChange("Session", state.id, "pending");
                  dispatch(setUserStatusActiveButton("pending"));
                }}
                title="Pending"
              /> */}
            <StatusTabe
              active={userStatusActiveButton === "completed"}
              onclick={() => {
                onStatusChange("Session", state.id, "completed");
                dispatch(setUserStatusActiveButton("completed"));
              }}
              title="Completed"
            />
            <StatusTabe
              active={userStatusActiveButton === "rejected"}
              onclick={() => {
                onStatusChange("Session", state.id, "rejected");
                dispatch(setUserStatusActiveButton("rejected"));
              }}
              title="Rejected"
            />
            <StatusTabe
              active={userStatusActiveButton === "expired"}
              onclick={() => {
                onStatusChange("Session", state.id, "expired");
                dispatch(setUserStatusActiveButton("expired"));
              }}
              title="Expired"
            />
          </>
        ) : (
          <>
            <StatusTabe
              active={userStatusActiveButton === "All"}
              onclick={() => {
                onStatusChange("Order", state.id, "All");
                dispatch(setUserStatusActiveButton("All"));
              }}
              title="All"
            />
            <StatusTabe
              active={userStatusActiveButton === "Incoming"}
              onclick={() => {
                onStatusChange("Order", state.id, "Incoming");
                dispatch(setUserStatusActiveButton("Incoming"));
              }}
              title="Incoming"
            />
            <StatusTabe
              active={userStatusActiveButton === "Active"}
              onclick={() => {
                onStatusChange("Order", state.id, "Active");
                dispatch(setUserStatusActiveButton("Active"));
              }}
              title="Active"
            />
            <StatusTabe
              active={userStatusActiveButton === "Completed"}
              onclick={() => {
                onStatusChange("Order", state.id, "Completed");
                dispatch(setUserStatusActiveButton("Completed"));
              }}
              title="Completed"
            />
            <StatusTabe
              active={userStatusActiveButton === "Rejected"}
              onclick={() => {
                onStatusChange("Order", state.id, "Rejected");
                dispatch(setUserStatusActiveButton("Rejected"));
              }}
              title="Rejected"
            />
            <StatusTabe
              active={userStatusActiveButton === "Expired"}
              onclick={() => {
                onStatusChange("Order", state.id, "Expired");
                dispatch(setUserStatusActiveButton("Expired"));
              }}
              title="Expired"
            />
          </>
        )}
      </StatusTabeContainer>

      <div className="search-container">
        <div className="input-fields">
          {userActiveButton === "Order Details" ? (
            <>
              <input
                type="text"
                placeholder="Search By Order id"
                {...register("id")}
              />
              <div className="custom-date-input-container">
                <input
                  type="date"
                  className="custom-date-input"
                  placeholder="Search by Date"
                  {...register("date")}
                />
              </div>
              <input
                type="text"
                placeholder="Search By Retailer"
                {...register("retailer")}
              />
            </>
          ) : userActiveButton === "Session Details" ? (
            <>
              <input
                type="text"
                placeholder="Search By Session Id"
                {...register("id")}
              />
              <input
                type="text"
                placeholder="Search By Dishes Name"
                {...register("name")}
              />
              <div className="custom-date-input-container">
                <input
                  type="date"
                  className="custom-date-input"
                  placeholder="Search by Date"
                  {...register("date")}
                />
              </div>
              <input
                type="text"
                placeholder="Search By Home Cook"
                {...register("cook")}
              />
            </>
          ) : null}
        </div>

        <div className="button-fields">
          <Button
            title="Search"
            width="16rem"
            fill="true"
            onclick={handleSubmit(search)}
          />
          <Button
            title="Reset"
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={handleResetFilters}
          />
        </div>
      </div>

      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th className="th">
                {userActiveButton === "Order Details"
                  ? "Order Id"
                  : "Session Id"}
              </th>
              {userActiveButton === "Order Details" ? (
                // <th className="th">Items</th>
                <></>
              ) : (
                <th>Dish Name</th>
              )}
              {userActiveButton === "Order Details" ? null : (
                <th className="th">Dish Image</th>
              )}
              <th>Date</th>
              <th className="th">Amount</th>
              <th>
                {userActiveButton === "Order Details"
                  ? "Retailer Name"
                  : "Home Cook"}
              </th>
              {userActiveButton === "Order Details" ? null : (
                <th className="th">Duration</th>
              )}
              {userStatusActiveButton === "All" && (
                <th className="th">Status</th>
              )}
              <th className="th">Actions</th>
            </tr>
          </thead>
          <tbody>
            {userActiveButton === "Order Details" ? (
              orderData?.data?.length > 0 ? (
                orderData.data.map((orders: any, index: number) => (
                  <tr key={index}>
                    <td className="th" style={{ whiteSpace: "nowrap" }}>{orders.generatedOrderId}</td>
                    {/* <td className="th">{orderData.totalCartItems}</td> */}
                    <td>{orders.createdAt?.split("T")[0]}</td>
                    <td className="th">{orders.totalAmount.toFixed(2)}</td>
                    <td>
                      {orders.retailerInfo?.firstName}{" "}
                      {orders.retailerInfo?.lastName}
                    </td>
                    {/* 
                      If userStatusActiveButton === "All", 
                      you might want a <td> for "Status" here 
                      as well, but the code references 
                      'orders.status' in an example 
                    */}
                    {userStatusActiveButton === "All" && (
                      <td>{orders.status}</td>
                    )}
                    <td className="actions th">
                      <div
                        className="view-container"
                        onClick={() =>
                          handleOrderViewPage(state.id, orders.generatedOrderId)
                        }
                      >
                        <img src={view} alt="img" />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <NoDataFound isShow={!isLoading} />
              )
            ) : sessionData?.length > 0 ? (
              sessionData.map((item: any, index: number) => (
                <tr key={index}>
                  <td className="th" style={{ whiteSpace: "nowrap" }}>{item.sessionId}</td>
                  <td>{item.dish?.dishName}</td>
                  <td>
                    <img
                      className="img"
                      src={item.dish?.coverImage[0]}
                      alt="img"
                    />
                  </td>
                  <td>{item.sessionDetails?.sessionDate.split("T")[0]}</td>
                  <td className="th">{item.sessionDetails?.sessionAmount}</td>
                  <td>{item.homeCook?.homeCookName}</td>
                  <td className="th">
                    {(() => {
                      const durationStr = item.sessionDetails?.sessionDuration;
                      if (!durationStr) return "N/A";
                      const [h, m] = durationStr.split(":");
                      const hours = parseInt(h, 10);
                      const minutes = parseInt(m, 10);
                      return `${hours} hour${hours !== 1 ? "s" : ""}${minutes > 0
                        ? `, ${minutes} minute${minutes !== 1 ? "s" : ""}`
                        : ""
                        }`;
                    })()}
                  </td>
                  {userStatusActiveButton === "All" && (
                    <td className="th">
                      <Status active={item.sessionDetails?.sessionStatus}>
                        {item.sessionDetails?.sessionStatus}
                      </Status>
                    </td>
                  )}
                  <td className="actions th">
                    <div
                      className="view-container"
                      onClick={() =>
                        handleDishViewPage(state.id, item.dish?.dishId , item?.sessionId)
                      }
                    >
                      <img src={view} alt="img" />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <NoDataFound isShow={!isLoading} />
            )}
          </tbody>
        </table>
      </div>

      <DietaryChoisePopup
        modalIsOpen={modalIsOpen}
        setIsOpen={setIsOpen}
        modalData={modalData}
      />

      <Fragment>
        <Pagination
          totalRecords={
            userActiveButton === "Order Details"
              ? ordersPaginationState?.totalItems
              : sessionsPaginationState?.totalSessions
          }
          perPage={10}
          handleFetchNextRecords={fetchNextRecords}
        />
      </Fragment>
    </Container>
  );
}

